/* LuluCamel Search Dropdown — recent + trending */
(function() {
  var RECENT_KEY = 'lc-recent-searches';
  var TRENDING = ['iphone 18 pro max', 'perfume', 'washing machine', 'airpods', 'ps5', 'laptop', 'watch', 'mens shoes', 'tablet', 'adidas'];

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveRecent(list) {
    localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 10)));
  }
  function addRecent(term) {
    term = (term || '').trim();
    if (!term) return;
    var list = getRecent().filter(function(t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    saveRecent(list);
  }
  function removeRecent(term) {
    saveRecent(getRecent().filter(function(t) { return t !== term; }));
    renderDrop();
  }

  function renderDrop() {
    var drop = document.getElementById('NoonSearchDrop');
    if (!drop) return;
    var recent = getRecent();
    var recentWrap = document.getElementById('NoonRecentWrap');
    var recentTags = document.getElementById('NoonRecentTags');
    var trendTags = document.getElementById('NoonTrendingTags');

    if (recentWrap) recentWrap.style.display = recent.length ? 'block' : 'none';
    if (recentTags) {
      recentTags.innerHTML = recent.map(function(t) {
        return '<span class="noon-sd-tag"><span class="noon-sd-term">' + escapeHtml(t) + '</span>' +
          '<button class="noon-sd-x" data-rm="' + escapeHtml(t) + '" aria-label="Remove">&times;</button></span>';
      }).join('');
    }
    if (trendTags) {
      trendTags.innerHTML = TRENDING.map(function(t) {
        return '<a class="noon-sd-tag" href="/search?q=' + encodeURIComponent(t) + '">' +
          '<span class="noon-sd-trend"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 6l-9.5 9.5-5-5L1 18"/><path d="M17 6h6v6"/></svg></span>' +
          escapeHtml(t) + '</a>';
      }).join('');
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function showDrop() {
    var drop = document.getElementById('NoonSearchDrop');
    if (drop) { renderDrop(); drop.style.display = 'block'; }
  }
  function hideDrop() {
    var drop = document.getElementById('NoonSearchDrop');
    if (drop) drop.style.display = 'none';
  }

  document.addEventListener('DOMContentLoaded', function() {
    var input = document.getElementById('NoonSearchInput');
    var form = document.getElementById('NoonSearchForm');
    if (!input || !form) return;

    input.addEventListener('focus', showDrop);
    input.addEventListener('click', showDrop);

    form.addEventListener('submit', function() {
      addRecent(input.value);
    });

    document.addEventListener('click', function(e) {
      var wrap = document.querySelector('.noon-search-wrap');
      if (wrap && !wrap.contains(e.target)) hideDrop();
      var x = e.target.closest('[data-rm]');
      if (x) { e.stopPropagation(); removeRecent(x.getAttribute('data-rm')); return; }
      var term = e.target.closest('.noon-sd-term');
      if (term) {
        input.value = term.textContent;
        form.submit();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') hideDrop();
    });
  });
})();
